import { ADMIN_URL } from "@/env";

/**
 * Resolve where to send the user after a successful login on the employer SPA.
 *
 * - ADMIN users → cross-origin to admin SPA dashboard.
 * - Regular users with at least one membership → dashboard (local).
 * - Regular users with no memberships → employer onboarding (local).
 *
 * `redirect` (if present and starting with `/`) is honored as a local path.
 */
export function resolvePostLoginUrl(opts: {
  globalRole: "USER" | "ADMIN";
  hasMembership: boolean;
  redirect?: string | null;
}): string {
  if (opts.globalRole === "ADMIN") {
    return `${ADMIN_URL}/dashboard`;
  }
  if (
    opts.redirect &&
    opts.redirect.startsWith("/") &&
    !opts.redirect.startsWith("//")
  ) {
    return opts.redirect;
  }
  if (opts.hasMembership) return "/dashboard";
  return "/onboarding/employer";
}

export function readRedirectParam(): string | null {
  if (typeof window === "undefined") return null;
  const params = new URLSearchParams(window.location.search);
  return params.get("redirect") ?? params.get("next");
}
